import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "control" ]

  controlTargetConnected(el) {
    this.element.addEventListener(
      "direct-upload:end",
      el[`${this.identifier}_listener`] = () => {
        el.removeAttribute("disabled")
      },
      { once: true }
    )
  }

  controlTargetDisconnected(el) {
    this.element.removeEventListener("direct-upload:end", el[`${this.identifier}_listener`])
    delete el[`${this.identifier}_listener`]
  }
}
